<div class="container-fluid">

  <h4 id="upper">Réalisation Indicateurs</h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div>

          </div>
          <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">

            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
            </div>
            <!-- End search -->
          </div>
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light  rwd-table">
                <tr>
                  <th>Indicateur</th>
                  <th>Valeur Cible Annuelle</th>
                  <th>Trim 1</th>
                  <th>Trim 2</th>
                  <th>Trim 3</th>
                  <th>Trim 4</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedItems; let index = index">
                  <td>{{item?.indicateur_details.libelle}}</td>
                  <td>{{item?.valeur_cible || '-'}}</td>
                  <td>{{item?.valeur_realisee_trim1 || '-'}}</td>
                  <td>{{item.valeur_realisee_trim2 || '-'}}</td>
                  <td>{{item?.valeur_realisee_trim3 || '-'}}</td>
                  <td>{{item?.valeur_realisee_trim4 || '-'}}</td>

                  <td>
                    <button (click)="openRealisation(item)" style="cursor: pointer;"
                      class="btn btn-success me-3  text-white" v-b-tooltip.hover title="Réaliser">
                      Réaliser
                    </button>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="isLoading === true">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Chargement en cours</h5>
                <div class="loader4"></div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Aucune donnée trouvée</h5>
              </div>
            </div>
          </div>

        </div>
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>
    </div>
  </div>
</div>
<ng-template #realisationModal let-modal>
  <div>
    <div class="">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h5 id="upper" class="modal-title">Réalisation Indicateurs</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Close click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">

              <!-- INFOS -->
              <div class="col-md-6">
                <div class="card shadow-sm p-3 mb-4">
                  <h6 class="text-center mb-4 fw-bold">Informations de l'indicateur</h6>

                  <div class="d-flex justify-content-between mb-2">
                    <span>Année</span>
                    <strong>{{items.annee}}</strong>
                  </div>

                  <div class="d-flex justify-content-between mb-2">
                    <span>Valeur cible</span>
                    <strong>{{items.valeur_cible}}</strong>
                  </div>

                  <div class="d-flex justify-content-between mb-3">
                    <span>Indicateur</span>
                    <strong>{{items.indicateur_details?.libelle}}</strong>
                  </div>

                  <hr>

                  <h6 class="mb-3">Écarts par trimestre</h6>

                  <div class="d-flex justify-content-between">
                    <span>Trimestre 1</span>
                    <span [ngStyle]="{'color': ecartColorTrim1}">{{ ecart_trim1 }}</span>
                  </div>

                  <div class="d-flex justify-content-between">
                    <span>Trimestre 2</span>
                    <span [ngStyle]="{'color': ecartColorTrim2}">{{ ecart_trim2 }}</span>
                  </div>

                  <div class="d-flex justify-content-between">
                    <span>Trimestre 3</span>
                    <span [ngStyle]="{'color': ecartColorTrim3}">{{ ecart_trim3 }}</span>
                  </div>

                  <div class="d-flex justify-content-between">
                    <span>Trimestre 4</span>
                    <span [ngStyle]="{'color': ecartColorTrim4}">{{ ecart_trim4 }}</span>
                  </div>

                </div>
              </div>

              <!-- FORMULAIRE -->
              <div class="col-md-6">
                <div class="card shadow-sm p-3">
                  <h6 class="text-center mb-4 fw-bold">Saisie des réalisations</h6>

                  <form>
                    <div class="row">

                      <div class="col-6 mb-3">
                        <label>Trimestre 1</label>
                        <input type="number" class="form-control" [(ngModel)]="planification.valeur_realisee_trim1"
                          name="t1" (ngModelChange)="calculerEcart()">
                      </div>

                      <div class="col-6 mb-3">
                        <label>Trimestre 2</label>
                        <input type="number" class="form-control" [(ngModel)]="planification.valeur_realisee_trim2"
                          name="t2" (ngModelChange)="calculerEcart()">
                      </div>

                      <div class="col-6 mb-3">
                        <label>Trimestre 3</label>
                        <input type="number" class="form-control" [(ngModel)]="planification.valeur_realisee_trim3"
                          name="t3" (ngModelChange)="calculerEcart()">
                      </div>

                      <div class="col-6 mb-3">
                        <label>Trimestre 4</label>
                        <input type="number" class="form-control" [(ngModel)]="planification.valeur_realisee_trim4"
                          name="t4" (ngModelChange)="calculerEcart()">
                      </div>

                    </div>

                    <div class="d-flex justify-content-end gap-2 mt-3">
                      <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('Close click')">
                        Annuler
                      </button>

                      <button type="button" class="btn btn-primary" (click)="saveRealisation()">
                        Enregistrer
                      </button>
                    </div>

                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Modal Footer -->

      </div>
    </div>
  </div>
</ng-template>



<p-confirmDialog />
<p-toast />

<ngx-ui-loader>

</ngx-ui-loader>